import api from '../../helpers/services/f2f/api';
import { createNotification } from 'react-redux-notify';
import { put, takeLatest, all } from 'redux-saga/effects';

import {
  FETCH_PERFORMER_EARNINGS_START
} from '../actions/ActionConstant';
import {
  fetchF2FPerformerEarningsSuccess,
  fetchF2FPerformerEarningsFailure
} from '../actions/Face2FaceAction';
import { getErrorNotificationMessage } from '../../components/helper/NotificationMessage';

function* getF2FEarnings() {
  try {
    const response = yield api.getMethod('face2face-payment/earning-history');
    if (response.data.success) {
      yield put(fetchF2FPerformerEarningsSuccess(response.data.data));
    } else {
      yield put(fetchF2FPerformerEarningsFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(response.data.error);
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchF2FPerformerEarningsFailure(error));
    const notificationMessage = getErrorNotificationMessage(
      error.response.data.error[0] || error.message,
    );
    yield put(createNotification(notificationMessage));
  }
}

export default function* pageSaga() {
  yield all([yield takeLatest(FETCH_PERFORMER_EARNINGS_START, getF2FEarnings)]);
}
